"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEARNING_API_ENPOINT = process.env.REACT_APP_LEARNING_API_ENPOINT || "https://api-digischool.kontinium.com/access/user";
exports.QUIZ_PLAYER_USER_DATA_KEY = process.env.REACT_APP_QUIZ_PLAYER_USER_DATA_KEY || window.location.host + "-quiz";
//# sourceMappingURL=app.settings.js.map